import { useState } from 'react';

const useForm = (initialData, tryToSubmit, validate) => {
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState({});

  // useEffect(() => {
  //   console.log("Errors:", errors)
  // }, [errors])

  const handleChange = (event, shouldRevalidate) => {
    const { target } = event;
    const { value } = target;
    const fieldName = target.name;
    let newFormData = {
      ...formData,
      [fieldName]: target.type === 'checkbox' ? target.checked : value,
    };
    setFormData(newFormData);
    if (shouldRevalidate) setErrors(validate(newFormData));
  };

  const handleBlur = () => {
    setErrors(validate(formData));
  };

  // Submit handler
  const handleSubmit = async (event, createAdvert) => {
    // eslint-disable-next-line no-console
    // console.log(formData);
    event.preventDefault();
    tryToSubmit(true);
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
    } else {
      await createAdvert();
    }
  };

  return {
    formData,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
  };
};

export default useForm;
